import Button from '@mui/joy/Button'
import DialogContent from '@mui/joy/DialogContent'
import DialogActions from '@mui/joy/DialogActions'
import DialogTitle from '@mui/joy/DialogTitle'
import Divider from '@mui/joy/Divider'
import Modal from '@mui/joy/Modal'
import ModalDialog from '@mui/joy/ModalDialog'

export const ConfirmModal = ({
    isOpen,
    title,
    message,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
}) => {
    return (
        <Modal open={isOpen} size="lg" role="alertdialog" variant="solid">
            <ModalDialog>
                <DialogTitle>{title}</DialogTitle>
                <Divider />
                <DialogContent>{message}</DialogContent>
                <DialogActions>
                    <Button variant="solid" color="danger" onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                    <Button variant="plain" color="neutral" onClick={onCancel}>
                        {cancelLabel}
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    )
}
